import React, { useState } from "react";
import tw from "twin.macro";

const ContactFormModal = tw.div`
  fixed inset-0
  bg-black bg-opacity-50
  flex items-center justify-center
  z-50
`;

const FormContainer = tw.div`
  relative
  bg-white
  rounded-lg
  p-8
  max-w-md
  w-full
  mx-4
`;

const FormTitle = tw.h3`
  text-2xl
  font-bold
  mb-4
  text-gray-900
`;

const Input = tw.input`
  w-full
  p-2
  mb-4
  border
  rounded
`;

const TextArea = tw.textarea`
  w-full
  p-2
  mb-4
  border
  rounded
  h-32
`;

const FormButton = tw.button`
  bg-primary-500
  text-white
  px-6
  py-2
  rounded
  hover:bg-primary-600
`;

const CloseButton = tw.button`
  absolute
  top-0
  right-0
  p-4
  text-gray-600
  hover:text-gray-800
`;

export default function DemoModal({
  isOpen,
  onClose,
  productName = "Tanga Access Log",
}) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  // NOUVEAU — Permet de savoir si l'envoi est en cours
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // MODIFIÉ — Envoi de la demande via l'API Tanga
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    try {
      const response = await fetch(
        "https://api.tangagroup.africa/api/v1/contact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,

            // NOUVEAU — On précise qu'il s'agit d'une demande de démo
            message: `Demande de démonstration - ${productName}

${formData.message}`,
          }),
        }
      );

      if (response.ok) {
        alert("Demande de démonstration envoyée avec succès !");

        // Réinitialisation du formulaire
        setFormData({
          name: "",
          email: "",
          message: "",
        });

        // Fermeture du modal
        onClose();
      } else {
        alert(
          "Échec de l'envoi de la demande. Veuillez réessayer."
        );
      }
    } catch (error) {
      console.error(
        "Erreur lors de l'envoi de la demande de démonstration :",
        error
      );

      alert(
        "Une erreur s'est produite. Veuillez réessayer plus tard."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <ContactFormModal onClick={onClose}>
      <FormContainer onClick={(e) => e.stopPropagation()}>
        <CloseButton
          type="button"
          onClick={onClose}
          aria-label="Fermer"
        >
          ×
        </CloseButton>

        <FormTitle>Demander une Démo</FormTitle>

        <form onSubmit={handleSubmit}>
          <Input
            type="text"
            name="name"
            placeholder="Votre nom"
            value={formData.name}
            onChange={handleInputChange}
            required
            disabled={isSubmitting}
          />

          <Input
            type="email"
            name="email"
            placeholder="Votre email"
            value={formData.email}
            onChange={handleInputChange}
            required
            disabled={isSubmitting}
          />

          <TextArea
            name="message"
            placeholder="Votre message"
            value={formData.message}
            onChange={handleInputChange}
            required
            disabled={isSubmitting}
          />

          <FormButton
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting
              ? "Envoi en cours..."
              : "Envoyer la demande"}
          </FormButton>
        </form>
      </FormContainer>
    </ContactFormModal>
  );
}

